module.exports = __webpack_public_path__ + "static/media/team.bde0725a.svg";